import styled from 'styled-components';
export const Container = styled.div `
  all: unset;
  justify-content: center;
  align-items: center;

  display: ${({ show }) => (show ? 'flex' : 'none')};

  @media ${({ theme }) => theme.device.xsmall} {
    height: 2rem;
  }
  @media ${({ theme }) => theme.device.medium} {
    height: 3rem;
  }
`;
export const Track = styled.div `
  all: unset;
  position: relative;
  /* width: 213px; */
  width: 160px;
  height: 0.5rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  ${({ theme }) => `background-color: rgba(${theme.colors.transparentBlack}, 0.12);`}
`;
export const Thumb = styled.span `
  min-width: 6px;
  height: 6px;
  background: ${({ theme }) => theme.colors.black};
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  -webkit-appearance: none;
`;
